
















import {Component, Vue} from '@/shared/component';
import {Prop} from "vue-property-decorator";
import {Form} from "@/shared/form";
import {Proprietaire, Upload} from "@/models";

import storeUpload from "@/stores/modules/upload";
import storeNotifier, {NotifyInterface} from "@/stores/modules/notifier";

import UploadProgress from '@/components/Input/UploadProgress.vue';

@Component({
	components: {
		UploadProgress
	}
})
export default class CrudDocumentProprietaireUploader extends Vue {

	@Prop({ type: Proprietaire, required: true }) private proprietaire: Proprietaire;

	private file: File = null;
	private upload: Upload = null;
	private form: Form = new Form();
	public acceptedType = ['image/jpeg', 'image/png']

	private async send(): Promise<void> {
		if (this.file && this.acceptedType.includes(this.file.type)) {
			await this.form.call(async () => {
				this.upload = await storeUpload.dispatch('postDocumentProprietaire', { proprietaire: this.proprietaire, file: this.file });
				this.upload = await storeUpload.dispatch('waitFinish', this.upload);
				storeNotifier.dispatch('notify', {
					type: 'success',
					message: 'Document envoyé'
				} as NotifyInterface);
			});
			this.file = null;
		} else {
			storeNotifier.dispatch('notify', {
				type: 'error',
				message: 'Format du fichier incorrect (format accepté: jpg, png)'
			} as NotifyInterface);
		}
	}
}
